// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Gmjo","buttons":"Footer_buttons__SfAZM"};